// yes I know I know, traveller is spelled with a double ll, but the genius that put travelers into cookies is the one to blame for this

export class CSECompanyData {
    numeroUsager: string
    typeUsager: number
    dateValidite: string
    nom: string
    prenom: string
    nomJeuneFille: string | null
    conjoint: string | null
    enfants: string[]
    codeDelegation: string
    regroupementRegional: string
    quotientFamilial: string
    anneeCalculqF: string | null
    numeroTelPerso: string | null
    numeroTelPortable: string
    mail: string
    cleAuthUsager: string

    constructor(data: any) {
        this.numeroUsager = data.numeroUsager
        this.typeUsager = data.typeUsager
        this.dateValidite = data.dateValidite
        this.nom = data.nom
        this.prenom = data.prenom
        this.nomJeuneFille = data.nomJeuneFille
        this.conjoint = data.conjoint
        this.enfants = data.enfants
        this.codeDelegation = data.codeDelegation
        this.regroupementRegional = data.regroupementRegional
        this.quotientFamilial = data.quotientFamilial
        this.anneeCalculqF = data.anneeCalculqF
        this.numeroTelPerso = data.numeroTelPerso
        this.numeroTelPortable = data.numeroTelPortable
        this.mail = data.mail
        this.cleAuthUsager = data.cleAuthUsager
    }
}

export class CSEData {
    company: string
    companyData: CSECompanyData | undefined
    travelerCompanions: CSETravellerCompanions

    constructor(
        company: string,
        companyData: CSECompanyData | undefined,
        travelerCompanions: CSETravellerCompanions
    ) {
        this.company = company
        this.companyData = companyData
        this.travelerCompanions = travelerCompanions
    }
}

export class CSETravellerCompanions {
    companyName: string
    companyId: string
    travalers: CSETraveller[]

    constructor(
        companyName: string,
        companyId: string,
        travalers: CSETraveller[]
    ) {
        this.companyName = companyName
        this.companyId = companyId
        this.travalers = travalers
    }
}

export class CSETraveller {
    id: number
    currentIdLabel: string
    idIdentifierNumber: string
    fisrtName: string
    lastName: string
    isMain: boolean
    isSelected = true
    title?: 'conjoint' | 'enfant' | string
    age: number

    constructor(
        id: number,
        currentIdLabel: string,
        idIdentifierNumber: string,
        fisrtName: string,
        lastName: string,
        isMain: boolean,
        isSelected = true,
        title?: 'conjoint' | 'enfant' | string,
        age = 18
    ) {
        this.id = id
        this.currentIdLabel = currentIdLabel
        this.idIdentifierNumber = idIdentifierNumber
        this.fisrtName = fisrtName
        this.lastName = lastName
        this.isMain = isMain
        this.isSelected = isSelected
        this.title = title
        this.age = age
    }
}

export function validateCSECompanyData(data: any): boolean {
    if (typeof data !== 'object') {
        console.error('validateCSECompanyData: data is not an object')
        return false
    }
    if (typeof data.numeroUsager !== 'string') {
        console.error('validateCSECompanyData: numeroUsager is not a string')
        return false
    }
    // if (typeof data.typeUsager !== 'number') {
    //     console.error('validateCSECompanyData: typeUsager is not a number')
    //     return false
    // }
    // if (typeof data.dateValidite !== 'string') {
    //     console.error('validateCSECompanyData: dateValidite is not a string')
    //     return false
    // }
    if (typeof data.nom !== 'string') {
        console.error('validateCSECompanyData: nom is not a string')
        return false
    }
    if (typeof data.prenom !== 'string') {
        console.error('validateCSECompanyData: prenom is not a string')
        return false
    }
    // if (data.nomJeuneFille !== null && typeof data.nomJeuneFille !== 'string') {
    //     console.error(
    //         'validateCSECompanyData: nomJeuneFille is not null and not a string'
    //     )
    //     return false
    // }
    // if (data.conjoint !== null && typeof data.conjoint !== 'object') {
    //     console.error(
    //         'validateCSECompanyData: conjoint is not null and not a string'
    //     )
    //     return false
    // }
    // if (!Array.isArray(data.enfants)) {
    //     console.error('validateCSECompanyData: enfants is not an array')
    //     return false
    // }
    // if (typeof data.codeDelegation !== 'string') {
    //     console.error('validateCSECompanyData: codeDelegation is not a string')
    //     return false
    // }
    // if (typeof data.regroupementRegional !== 'string') {
    //     console.error(
    //         'validateCSECompanyData: regroupementRegional is not a string'
    //     )
    //     return false
    // }
    // if (typeof data.quotientFamilial !== 'string') {
    //     console.error(
    //         'validateCSECompanyData: quotientFamilial is not a string'
    //     )
    //     return false
    // }
    // if (data.anneeCalculqF !== null && typeof data.anneeCalculqF !== 'string') {
    //     console.error(
    //         'validateCSECompanyData: anneeCalculqF is not null and not a string'
    //     )
    //     return false
    // }
    // if (
    //     data.numeroTelPerso !== null &&
    //     typeof data.numeroTelPerso !== 'string'
    // ) {
    //     console.error(
    //         'validateCSECompanyData: numeroTelPerso is not null and not a string'
    //     )
    //     return false
    // }
    // if (
    //     data.numeroTelPerso !== null &&
    //     typeof data.numeroTelPortable !== 'string'
    // ) {
    //     console.error(
    //         'validateCSECompanyData: numeroTelPortable is not a string'
    //     )
    //     return false
    // }
    // if (data.mail !== null && typeof data.mail !== 'string') {
    //     console.error('validateCSECompanyData: mail is not a string')
    //     return false
    // }
    // if (typeof data.cleAuthUsager !== 'string') {
    //     console.error('validateCSECompanyData: cleAuthUsager is not a string')
    //     return false
    // }

    return true
}

export function validateCSETraveller(traveler: any): boolean {
    if (typeof traveler !== 'object') {
        console.error('validateCSETraveler: traveler is not an object')
        return false
    }
    if (typeof traveler.id !== 'number') {
        console.error('validateCSETraveler: id is not a number')
        return false
    }
    if (
        typeof traveler.currentIdLabel !== 'undefined' &&
        typeof traveler.currentIdLabel !== 'string'
    ) {
        console.error('validateCSETraveler: currentIdLabel is not a string')
        return false
    }
    if (
        typeof traveler.idIdentifierNumber !== 'undefined' &&
        typeof traveler.idIdentifierNumber !== 'string'
    ) {
        console.error('validateCSETraveler: idIdentifierNumber is not a string')
        return false
    }
    if (
        typeof traveler.fisrtName !== 'undefined' &&
        typeof traveler.fisrtName !== 'string'
    ) {
        console.error('validateCSETraveler: fisrtName is not a string')
        return false
    }
    if (
        typeof traveler.lastName !== 'undefined' &&
        typeof traveler.lastName !== 'string'
    ) {
        console.error('validateCSETraveler: lastName is not a string')
        return false
    }
    if (typeof traveler.isMain !== 'boolean') {
        console.error('validateCSETraveler: isMain is not a boolean')
        return false
    }
    if (
        typeof traveler.isSelected !== 'undefined' &&
        typeof traveler.isSelected !== 'boolean'
    ) {
        console.error('validateCSETraveler: isSelected is not a boolean')
        return false
    }
    if (
        typeof traveler.title !== 'undefined' &&
        typeof traveler.title !== 'string'
    ) {
        console.error('validateCSETraveler: title is not a string')
        return false
    }
    if (
        typeof traveler.age !== 'undefined' &&
        typeof traveler.age !== 'number'
    ) {
        console.error('validateCSETraveler: age is not a number')
        return false
    }

    return true
}

export function validateCSETravellerCompanions(data: any): boolean {
    if (typeof data !== 'object') {
        console.error('validateCSETravellerCompanions: data is not an object')
        return false
    }
    if (typeof data.companyName !== 'string') {
        console.error(
            'validateCSETravellerCompanions: companyName is not a string'
        )
        return false
    }
    if (typeof data.companyId !== 'string') {
        console.error(
            'validateCSETravellerCompanions: companyId is not a string'
        )
        return false
    }
    if (!Array.isArray(data.travalers)) {
        console.error(
            'validateCSETravellerCompanions: travalers is not an array'
        )
        return false
    }
    if (
        !data.travalers.every((traveler: any) => validateCSETraveller(traveler))
    ) {
        return false
    }

    return true
}

export function buildCSETraveller(data: any): CSETraveller {
    if (!validateCSETraveller(data))
        throw new Error('Invalid CSETraveler object')

    return new CSETraveller(
        data.id,
        data.currentIdLabel,
        data.idIdentifierNumber,
        data.fisrtName,
        data.lastName,
        data.isMain,
        data.isSelected,
        data.title,
        data.age
    )
}

export function buildCSETravelerCompanions(data: any): CSETravellerCompanions {
    if (!validateCSETravellerCompanions(data))
        throw new Error('Invalid CSETravelerCompanions object')

    const travalers = data.travalers.map((travaler: any) =>
        buildCSETraveller(travaler)
    )

    return new CSETravellerCompanions(
        data.companyName,
        data.companyId,
        travalers
    )
}

export function buildCSEData(
    company: string,
    companyData: any,
    travalerCompanions: any
): CSEData {
    const isCgos: boolean =
        company.toLowerCase().includes('cgos') ? true : false
    return new CSEData(
        company,
        buildCSECompanyData(companyData, isCgos),
        buildCSETravelerCompanions(travalerCompanions)
    )
}

export function buildCSECompanyData(
    data: any,
    isCgos?: boolean
): CSECompanyData | undefined {
    if (!isCgos) return
    if (!validateCSECompanyData(data))
        throw new Error('Invalid CSECompanyData object')
    return new CSECompanyData(data)
}
